'use client';

import { useSearchParams } from 'next/navigation';
import Layout from '@/components/layout/Layout';
import DefaultPage from '@/components/templates/DefaultPage';
import ProductGrid from '@/components/products/ProductGrid';
import ProductCategories from '@/components/products/ProductCategories';

export default function ProductsPage() {
  const searchParams = useSearchParams();
  const categorySlug = searchParams.get('category');

  return (
    <Layout>
      <DefaultPage
        title="产品中心"
        subtitle="探索我们的优质产品"
        layout="two-column"
        leftColumn={
          <div className="elementor-widget-wrap">
            {/* 产品网格内容 */}
            <ProductGrid categorySlug={categorySlug || undefined} />
          </div>
        }
        breadcrumbItems={[
          { name: 'Home', url: '/' },
          { name: 'Products', url: '/products' },
        ]}
      />
    </Layout>
  );
}

